import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/app/(carvana-layout)/vehicle/[vehicleId]/VehicleLoadingSkeleton.tsx");
